var map = {
	"./Blog Post.svg": "ee17",
	"./Collection Page.svg": "af4e",
	"./Complete Store.svg": "22b4",
	"./Home Page.svg": "46e8",
	"./Landing Page.svg": "7baf",
	"./Product Page.svg": "68e8",
	"./starter.svg": "a131"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25e8";